/*
 * Copyright (c) 2020, Matthew T. Kaufman
 */

import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;